import { useTranslation } from 'react-i18next'

const PRIVACY_POLICY_URL = 'https://www.jobilla.com/ai/privacy-policy'

/**
 * The pre-connect scope disclosure Google's OAuth verification requires: what
 * calendar data we access, why, and a link to the privacy policy — shown before
 * the user starts the consent flow.
 */
export function LegalClarifications() {
	const { t } = useTranslation('common')

	return (
		<div className="text-sm text-grey-600">
			<p>{t('account.calendar.disclosure.intro')}</p>
			<ul className="mt-1 list-disc pl-5">
				<li>{t('account.calendar.disclosure.scope_freebusy')}</li>
				<li>{t('account.calendar.disclosure.scope_events')}</li>
			</ul>
			<p className="mt-2">
				{t('account.calendar.disclosure.reassurance')}{' '}
				<a
					href={PRIVACY_POLICY_URL}
					target="_blank"
					rel="noreferrer"
					className="text-brand-600 underline"
				>
					{t('account.calendar.disclosure.privacy_cta')}
				</a>
			</p>
		</div>
	)
}
